<script lang="ts">
import { faBell, faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NavBar',
  emits: ['toggleSidebar'],
  data() {
    return {
      faBell,
      faBars
    }
  },
  components: { FontAwesomeIcon },
})

</script>

<template>
  <header
    class="sticky top-0 z-40 flex h-16 items-center justify-between border-b border-gray-200 bg-white px-6 shadow-sm rounded-b-2xl">
    <h1 class="text-lg mdtext-xl font-semibold text-gray-900 select-none">
      Dashboard
    </h1>


    <div class="hidden md:flex items-center gap-4 cursor-not-allowed">
      <FontAwesomeIcon :icon="faBell" />
    </div>

    <button class="md:hidden p-2 rounded-lg hover:bg-gray-100" @click="$emit('toggleSidebar')">
      <FontAwesomeIcon :icon="faBars" />
    </button>
  </header>
</template>
